export const appName = '开源问卷系统-TduckSurvey填鸭表单'
